import axios from '../../utils/axios2';

export default {
    namespaced: true,
    
    state : {
        jobcardExternalMaintenance: null,
        jobcardExternalMaintenances: null
    },
    mutations: {
        setJobcardExternalMaintenance(state, payload) {
            state.jobcardExternalMaintenance = payload;
        },
        setJobcardExternalMaintenances(state, payload) {
            state.jobcardExternalMaintenances = payload;
        }
    },
    actions: {
        fetchJobcardExternalMaintenances({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `jobcard-external-maintenances?jobcard_id=${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setJobcardExternalMaintenances", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
            });
        },
        fetchJobcardExternalMaintenance({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `jobcard-external-maintenances/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setJobcardExternalMaintenance", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        storeJobcardExternalMaintenance({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `jobcard-external-maintenances`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        updateJobcardExternalMaintenance({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `jobcard-external-maintenances/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        removeJobcardExternalMaintenance({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `jobcard-external-maintenances/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        }
    }
}